import TextEllipsis from '@Components/Common/Tooltip/TextEllipsis';
import { Flex, Tag, Truncate } from '@tonic-one/react';
import { useMemo } from 'react';

const TagListOverflow = (props: {
  tags: string[];
  lines?: number;
  sortByLength?: boolean;
}) => {
  const { tags: _tags, lines = 1, sortByLength = true } = props;

  const tags = useMemo(() => {
    if (!Array.isArray(_tags)) {
      return [];
    }
    if (!sortByLength) {
      return _tags;
    }
    return _tags.sort((a, b) => a.length - b.length);
  }, [_tags, sortByLength]);

  const tooltipLabel = (
    <Flex flexWrap="wrap" gap="1x">
      {tags.map((tag) => (
        <Tag key={tag}>{tag}</Tag>
      ))}
    </Flex>
  );
  return (
    <TextEllipsis
      lines={lines}
      tooltipLabel={tooltipLabel}
      popperProps={{
        width: 'max-content',
        maxWidth: `400px`,
        usePortal: true,
      }}
    >
      {tags.map((tag) => (
        <Tag key={tag} mr="1x" mb="1x" height="6x" position="static">
          <Truncate>{tag}</Truncate>
        </Tag>
      ))}
    </TextEllipsis>
  );
};

export default TagListOverflow;
